/* Direct theme integrations must use the same permissions as Shopify pixels. */
(function () {
  'use strict';
  const integrations = [
    { id: 'ahq-gtm', src: 'https://www.googletagmanager.com/gtm.js?id=GTM-WZSMMZ74', purposes: ['analytics', 'marketing', 'sharing'] },
    { id: 'ahq-identity', src: 'https://cdn.v3.identitypxl.app/pixels/5cfb1da6-11d0-4f8d-aa92-72a4a3b42875/p.js', purposes: ['marketing', 'sharing'] },
    { id: 'ahq-callrail', src: 'https://cdn.callrail.com/companies/370958660/67a7f787116ed34cddce/12/swap.js', purposes: ['analytics', 'marketing'] }
  ];
  // HubSpot also arrives through Shopify's app-generated header. Its redundant
  // theme loader is removed; app consent configuration must be fixed in admin.
  const loaded = new Set();
  let reloading = false;
  window.dataLayer = window.dataLayer || [];
  function consentCommand() { window.dataLayer.push(arguments); }
  consentCommand('consent', 'default', {
    analytics_storage: 'denied', ad_storage: 'denied',
    ad_user_data: 'denied', ad_personalization: 'denied'
  });

  function applyPermissions() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || reloading) return;
    let permissions;
    try {
      permissions = {
        analytics: privacy.analyticsProcessingAllowed() === true,
        marketing: privacy.marketingAllowed() === true,
        sharing: privacy.saleOfDataAllowed() === true && navigator.globalPrivacyControl !== true
      };
    } catch (_) { return; } // Leave direct trackers unloaded if permissions are unavailable.
    consentCommand('consent', 'update', {
      analytics_storage: permissions.analytics ? 'granted' : 'denied',
      ad_storage: permissions.marketing ? 'granted' : 'denied',
      ad_user_data: permissions.marketing && permissions.sharing ? 'granted' : 'denied',
      ad_personalization: permissions.marketing && permissions.sharing ? 'granted' : 'denied'
    });
    const allowed = integration => integration.purposes.every(purpose => permissions[purpose]);
    if (integrations.some(integration => loaded.has(integration.id) && !allowed(integration))) {
      // Scripts can keep timers/listeners after removal. Reload after Shopify has
      // saved the choice so the next document cannot initialize revoked trackers.
      reloading = true;
      window.location.reload();
      return;
    }
    integrations.forEach(integration => {
      if (!allowed(integration) || loaded.has(integration.id)) return;
      loaded.add(integration.id);
      if (integration.id === 'ahq-gtm') {
        window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
      }
      const script = document.createElement('script');
      script.id = integration.id;
      script.src = integration.src;
      script.async = true;
      document.head.appendChild(script);
    });
  }

  document.addEventListener('visitorConsentCollected', applyPermissions);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) applyPermissions();
    });
  }
})();
